(() => {
  if (window.pampasMobileQuickAddReady) return;
  window.pampasMobileQuickAddReady = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  let activeButton = null;
  let activeProduct = null;

  /* PL-02: the one ₪ format (window.PMMoney, layout/theme.liquid) */
  const money = (cents) => (window.PMMoney ? window.PMMoney(cents) : '₪' + Math.round(Number(cents || 0)) / 100);

  const mobileStyleProperties = [
    'appearance',
    '-webkit-appearance',
    'background',
    'background-color',
    'background-image',
    'border',
    'box-shadow'
  ];

  const syncMobilePresentation = (button) => {
    /* REQ-023 (Ran 04.11): the sale grid draws its own corner button (assets/pm-sale-grid.css) */
    if (button.closest('.pmc-grid')) {
      mobileStyleProperties.forEach((property) => button.style.removeProperty(property));
      return;
    }
    if (mobile.matches) {
      button.style.setProperty('appearance', 'none', 'important');
      button.style.setProperty('-webkit-appearance', 'none', 'important');
      button.style.setProperty('background', '#faf6f1', 'important');
      button.style.setProperty('background-color', '#faf6f1', 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('border', '1px solid rgba(136, 92, 58, 0.55)', 'important');
      button.style.setProperty('box-shadow', '0 2px 7px rgba(61, 46, 32, 0.10)', 'important');
      return;
    }

    mobileStyleProperties.forEach((property) => button.style.removeProperty(property));
  };

  const decorateButton = (button) => {
    if (!button || button.dataset.pmQuickDecorated === 'true') return;
    if (button.dataset.personalizationRequired === 'true') {
      button.dataset.pmQuickDecorated = 'true';
      button.classList.add('pm-grid-cart--options');
      return;
    }
    const label = (button.textContent || '').replace(/\s+/g, ' ').trim();
    const hasOptions = /בחירת אפשרויות/.test(label);
    button.dataset.pmQuickDecorated = 'true';
    button.classList.add(hasOptions ? 'pm-grid-cart--options' : 'pm-grid-cart--add');
    button.textContent = '';

    const text = document.createElement('span');
    text.className = 'pm-grid-cart-label';
    text.textContent = label;
    button.append(text);

    const symbol = document.createElement('span');
    symbol.className = 'pm-grid-cart-symbol';
    symbol.setAttribute('aria-hidden', 'true');
    symbol.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M6.25 8.5h11.5l.85 11H5.4l.85-11Z" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 9V6.7a3 3 0 0 1 6 0V9" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round"/><path d="M12 12.2v4.2M9.9 14.3h4.2" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round"/></svg>';
    button.append(symbol);
  };

  const decorateButtons = (root = document) => {
    root.querySelectorAll?.('.pampas-grid-cart-btn').forEach((button) => {
      decorateButton(button);
      syncMobilePresentation(button);
    });
  };

  const dialog = document.createElement('div');
  dialog.className = 'pm-mobile-quick-add';
  dialog.hidden = true;
  dialog.innerHTML = `
    <div class="pm-mobile-quick-add__backdrop" data-pm-quick-close></div>
    <div class="pm-mobile-quick-add__dialog" role="dialog" aria-modal="true" aria-labelledby="pmMobileQuickAddTitle" dir="rtl">
      <button class="pm-mobile-quick-add__close" type="button" data-pm-quick-close aria-label="סגירה">×</button>
      <h2 class="pm-mobile-quick-add__title" id="pmMobileQuickAddTitle"></h2>
      <label class="pm-mobile-quick-add__label" for="pmMobileQuickAddVariant">בחרו אפשרות</label>
      <select class="pm-mobile-quick-add__select" id="pmMobileQuickAddVariant"></select>
      <button class="pm-mobile-quick-add__submit" type="button">הוספה לעגלה</button>
      <p class="pm-mobile-quick-add__status" role="status" aria-live="polite"></p>
    </div>`;

  const title = dialog.querySelector('.pm-mobile-quick-add__title');
  const select = dialog.querySelector('.pm-mobile-quick-add__select');
  const submit = dialog.querySelector('.pm-mobile-quick-add__submit');
  const status = dialog.querySelector('.pm-mobile-quick-add__status');

  const closeDialog = () => {
    if (dialog.hidden) return;
    dialog.hidden = true;
    document.body.classList.remove('pm-mobile-quick-add-open');
    activeButton?.focus();
    activeButton = null;
    activeProduct = null;
  };

  const openDialog = (product, button) => {
    const variants = product.variants.filter((variant) => variant.available);
    activeProduct = product;
    activeButton = button;
    title.textContent = product.title;
    select.replaceChildren();

    variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = `${variant.title} — ${money(variant.price)}`;
      select.appendChild(option);
    });

    status.textContent = '';
    submit.disabled = variants.length === 0;
    dialog.hidden = false;
    document.body.classList.add('pm-mobile-quick-add-open');
    window.requestAnimationFrame(() => select.focus());
  };

  const announceAdded = (button) => {
    const label = button.querySelector?.('.pm-grid-cart-label');
    const original = label ? label.textContent : button.textContent;
    if (label) label.textContent = 'נוסף לעגלה ✓';
    else button.textContent = 'נוסף לעגלה ✓';
    window.setTimeout(() => {
      if (label) label.textContent = original;
      else button.textContent = original;
    }, 1600);
  };

  const addVariant = async (variantId, button) => {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'מוסיף לעגלה…';

    try {
      const response = await fetch(window.theme?.routes?.cartAdd || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Cart request failed');

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: result.items?.[0] || result, addToCartBtn: button }
        })
      );
      document.dispatchEvent(new CustomEvent('cart:updated'));
      announceAdded(button);
      status.textContent = 'המוצר נוסף לעגלה';
      window.setTimeout(closeDialog, 450);
    } catch (error) {
      status.textContent = 'לא הצלחנו להוסיף לעגלה. נסו שוב.';
      console.error('[Pampas quick add]', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  const loadProduct = async (grid) => {
    const handle = grid?.dataset.productHandle;
    if (!handle) throw new Error('Missing product handle');
    const root = window.theme?.routes?.home || window.Shopify?.routes?.root || '/';
    const url = `${root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
    return response.json();
  };

  const initVolumePricing = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-pm-volume-pricing]')) roots.push(scope);
    scope.querySelectorAll?.('[data-pm-volume-pricing]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.dataset.pmDynamicPricingInitialized === 'true') return;
      /* REQ-010: on a product page this script now loads for the recommendation cards; the page's own quantity pricing keeps its script */
      if (document.body.classList.contains('template-product') && !root.closest('.modal--quick-shop')) return;
      root.dataset.pmDynamicPricingInitialized = 'true';

      const productSection = root.closest('.product-section') || root.closest('.modal--quick-shop') || root.parentElement;
      const rows = Array.from(root.querySelectorAll('tbody tr[data-min]'));
      const summary = root.querySelector('[data-volume-summary]');
      const pricesNode = root.querySelector('[data-volume-variant-prices]');
      let variantPrices = {};

      try {
        variantPrices = JSON.parse(pricesNode?.textContent || '{}');
      } catch (error) {
        console.error('[Pampas volume pricing] Invalid variant prices', error);
      }

      /* PL-02: the one ₪ format (window.PMMoney, layout/theme.liquid) */
      const formatMoney = (cents) => (window.PMMoney ? window.PMMoney(cents) : '₪' + Math.round(Number(cents || 0)) / 100);

      const selectedPrice = () => {
        const idInput = productSection?.querySelector('form[action*="/cart/add"] [name="id"]');
        return Number(variantPrices[idInput?.value] || root.dataset.currentPrice || 0);
      };

      const selectedQuantity = () => {
        const quantityInput = productSection?.querySelector('input[name="quantity"]');
        return Math.max(1, parseInt(quantityInput?.value, 10) || 1);
      };

      const update = () => {
        const basePrice = selectedPrice();
        const quantity = selectedQuantity();
        let activeRow = rows[0];

        rows.forEach((row) => {
          const minimum = Number(row.dataset.min || 1);
          const maximum = row.dataset.max ? Number(row.dataset.max) : Infinity;
          const discount = Number(row.dataset.discount || 0);
          const discountedPrice = (window.PMTiers ? window.PMTiers.unit(basePrice, discount) : basePrice - Math.floor(basePrice * discount / 100));
          const savingPerUnit = basePrice - discountedPrice;
          const isActive = quantity >= minimum && quantity <= maximum;
          const priceCell = row.querySelector('[data-unit-price]');
          const savingCell = row.querySelector('[data-unit-saving]');

          if (priceCell) priceCell.textContent = formatMoney(discountedPrice);
          if (savingCell) savingCell.textContent = savingPerUnit > 0 ? formatMoney(savingPerUnit) : '—';
          row.classList.toggle('is-active', isActive);
          if (isActive) activeRow = row;
        });

        if (!summary || !activeRow) return;
        const activeDiscount = Number(activeRow.dataset.discount || 0);
        const currentUnitPrice = (window.PMTiers ? window.PMTiers.unit(basePrice, activeDiscount) : basePrice - Math.floor(basePrice * activeDiscount / 100));
        /* PL-03: the line total as Shopify's automatic discount computes it (window.PMTiers, layout/theme.liquid) */
        const lineTotal = currentUnitPrice * quantity;
        const totalSaving = basePrice * quantity - lineTotal;

        summary.textContent = activeDiscount > 0
          ? `${quantity} יחידות · ${formatMoney(lineTotal)} · חיסכון כולל ${formatMoney(totalSaving)}`
          : `${quantity} יחידות · מחיר רגיל ${formatMoney(currentUnitPrice)} ליחידה`;
      };

      productSection?.addEventListener('input', (event) => {
        if (event.target.matches('input[name="quantity"], [name="id"]')) update();
      });
      productSection?.addEventListener('change', (event) => {
        if (event.target.matches('input[name="quantity"], [name="id"], select')) {
          window.requestAnimationFrame(update);
        }
      });
      productSection?.addEventListener('click', (event) => {
        if (event.target.closest('.js-qty__adjust')) window.requestAnimationFrame(update);
      });
      productSection?.addEventListener('variant:change', () => window.requestAnimationFrame(update));
      update();
    });
  };

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('.pampas-grid-cart-btn');
      if (!button) return;
      if (button.dataset.personalizationRequired === 'true') return;

      // Desktop keeps the full quick shop for products with options. Products
      // labelled "add to cart" have one default variant and can be added directly.
      if (!mobile.matches && !button.classList.contains('pm-grid-cart--add')) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      const buttonLabel = button.querySelector('.pm-grid-cart-label');
      const original = buttonLabel ? buttonLabel.textContent : button.textContent;
      if (buttonLabel) buttonLabel.textContent = 'טוען…';
      else button.textContent = 'טוען…';

      const restoreLabel = () => {
        if (buttonLabel) buttonLabel.textContent = original;
        else button.textContent = original;
      };

      try {
        const product = await loadProduct(button.closest('.grid-product'));
        const available = product.variants.filter((variant) => variant.available);
        if (available.length === 0) throw new Error('No available variants');

        if (product.variants.length === 1) {
          restoreLabel();
          button.removeAttribute('aria-busy');
          await addVariant(available[0].id, button);
        } else if (mobile.matches) {
          restoreLabel();
          button.removeAttribute('aria-busy');
          openDialog(product, button);
        } else {
          restoreLabel();
          button.removeAttribute('aria-busy');
        }
      } catch (error) {
        restoreLabel();
        button.removeAttribute('aria-busy');
        console.error('[Pampas quick add]', error);
        window.location.href = button.closest('.grid-product')?.querySelector('.grid-product__image-link')?.href || '/collections/all';
      }
    },
    true
  );

  submit.addEventListener('click', () => {
    if (!activeProduct || !activeButton || !select.value) return;
    addVariant(select.value, submit);
  });
  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-pm-quick-close]')) closeDialog();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) closeDialog();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        decorateButtons(node);
        initVolumePricing(node);
      });
    });
  });

  const mount = () => {
    if (!dialog.isConnected) document.body.appendChild(dialog);
    decorateButtons();
    initVolumePricing();
    observer.observe(document.body, { childList: true, subtree: true });
  };
  document.addEventListener('pampas:collection:products-loaded', (event) => {
    (event.detail?.products || []).forEach((product) => {
      decorateButtons(product);
      initVolumePricing(product);
    });
  });
  mobile.addEventListener?.('change', () => decorateButtons());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
